var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ maxWidth: _vm.maxWidth })},[_c('nuxt-img',_vm._b({},'nuxt-img',Object.assign({}, _vm.$attrs, _vm.$props),false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }